import { render, staticRenderFns } from "./Drama.vue?vue&type=template&id=83b42b72&"
import script from "./Drama.vue?vue&type=script&lang=js&"
export * from "./Drama.vue?vue&type=script&lang=js&"
import style0 from "./Drama.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports